import { ImageTypeEnum } from '@/components/carousel/types/CarouselTypes';
import { KiaPage_Pagebuilder_Blocks_CarCarousel } from '@/graphql/generated/graphql';
import Carousel from '@/pages/carousel/carousel';
import { formatFields } from '../utils/format';

const CarCarousel = ({
  blockId,
  displayCta,
  displayDescriptions,
  functions,
  displayPrices,
  displayLeasing,
  imageType,
  businessEdition,
}: KiaPage_Pagebuilder_Blocks_CarCarousel) => {
  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <Carousel
        hideControls
        privateMileages={'true'}
        imageType={ImageTypeEnum[imageType]}
        fields={formatFields(
          functions,
          displayCta,
          displayDescriptions,
          displayPrices,
          displayLeasing,
        )}
        onlyBusinessEdition={
          businessEdition === 'Visa bara Business Edition' ? 'true' : undefined
        }
        includeBusinessEdition={
          businessEdition === 'Inkludera Business Edition' ? 'true' : undefined
        }
      />
    </section>
  );
};

export default CarCarousel;
